'use client'

import { useCallback } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { Button, toast } from '@ui/web/components'
import { FaveIcon } from '@ui/web/icon'
import cn from '@config/tailwind/cn'

import { useSharedTRPC } from '../context'

interface LoveLessonModuleButtonProps {
  lessonModuleId: string
  className?: string
}

export function LoveLessonModuleButton({ lessonModuleId, className }: LoveLessonModuleButtonProps) {
  const trpc = useSharedTRPC()
  const queryClient = useQueryClient()

  const doILoveQuery = useQuery(trpc.loveLessonModule.doILoveThisLessonModule.queryOptions({ lessonModuleId }))

  const likeMutation = useMutation(
    trpc.loveLessonModule.likeLessonModule.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.loveLessonModule.doILoveThisLessonModule.queryKey({ lessonModuleId }),
        })
        await queryClient.invalidateQueries({
          queryKey: trpc.loveLessonModule.getAllLovedLessonModules.infiniteQueryKey(),
        })
      },
    }),
  )

  const unlikeMutation = useMutation(
    trpc.loveLessonModule.unlikeLessonModule.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.loveLessonModule.doILoveThisLessonModule.queryKey({ lessonModuleId }),
        })
        await queryClient.invalidateQueries({
          queryKey: trpc.loveLessonModule.getAllLovedLessonModules.infiniteQueryKey(),
        })
      },
    }),
  )

  const isLoved = doILoveQuery.isSuccess && doILoveQuery.data === true

  const handleClick = useCallback(() => {
    if (isLoved) {
      // const toastId = toast.loading('Menghapus modul dari Pilihanku...')
      unlikeMutation.mutate(
        { lessonModuleId },
        {
          onSuccess: () => {
            // toast.dismiss(toastId)
            // toast.success('Modul berhasil dihapus dari Pilihanku')
          },
          onError: () => {
            // toast.dismiss(toastId)
            toast.error('Gagal menghapus modul dari Pilihanku')
          },
        },
      )
    } else {
      // const toastId = toast.loading('Menyimpan modul ke Pilihanku...')
      likeMutation.mutate(
        { lessonModuleId },
        {
          onSuccess: () => {
            // toast.dismiss(toastId)
            // toast.success('Modul tersimpan di Pilihanku')
          },
          onError: () => {
            // toast.dismiss(toastId)
            toast.error('Gagal menyimpan modul ke Pilihanku')
          },
        },
      )
    }
  }, [isLoved, lessonModuleId, likeMutation, unlikeMutation])

  return (
    <Button
      size='icon'
      variant='ghost'
      className={cn('srd:shrink-0 srd:rounded-full', isLoved && 'srd:bg-blue-100/20', className)}
      disabled={likeMutation.isPending || unlikeMutation.isPending}
      onClick={handleClick}
    >
      <FaveIcon className='srd:size-6' color='var(--neutral-black)' />
    </Button>
  )
}
